/*
name: main.js
discription: Javascript Datei
required: functions.js
Author: Robert Menghini
*/

import UIkit from '@node_modules/uikit';

//import $ from '../vendors/jquery-3.2.1.min';

// window.jQuery = $;
// window.$ = $;

function animateCSS(element, animationName, callback) {
	var node = document.querySelector(element);
	node.classList.add('animated', animationName);

	function handleAnimationEnd() {
		node.classList.remove('animated', animationName);
		node.removeEventListener('animationend', handleAnimationEnd);
		
		if (typeof callback === 'function') callback();
	}

	node.addEventListener('animationend', handleAnimationEnd);
}

'use strict';

/**
 * Geraetespezifische Klassen ins html-Tag setzen
*/

(function(){
   var 	isMobile, 
         isIOS,
         ua = navigator.userAgent;


   var html =  document.documentElement;

   html.classList.remove('cc-no-js');
   html.classList.add('cc-js');
   
   isMobile = /Mobile|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Windows Phone|Opera Mini/i.test(ua);
   isIOS = /iPhone|iPad|iPod/i.test(ua);
   
   if ( isMobile ) {
      html.classList.remove('cc-desktop');
      html.classList.add('cc-mobile');
   }//endif

   if ( isIOS ) {
      html.classList.add('cc-iOS');
   }//endif
})();

/**
 * Spamschutz alle -@- entschluesseln
 */

	(function(){


	var 	replaced,
			at = '-@-',
			reg = RegExp(at,'g');

	var mailtoLinks = document.querySelectorAll('a[href*="mailto"]');


	// Alternative fuer arr.foreach()
	for ( var i = 0, len = mailtoLinks.length; i < len; i++ ) {

		// replace Link-Attribute

		var mailtoLink = mailtoLinks[i];

		replaced = mailtoLink.getAttribute('href').replace(reg,'@');
		mailtoLink.setAttribute('href',replaced);

		// replace HTML
		
		replaced = mailtoLink.innerHTML.replace(reg,'@');
		mailtoLink.innerHTML = replaced;

	}//end for

})();

/**
 * Scroll-Top ein, ausblenden
 */

(function() {
	
	var 	showPos = 500,
			pageWrapper = document.getElementById( 'pageWrapper' ),
			backTopBtn = document.createElement( 'a' ),
			scrollTop = window.pageYOffset || document.documentElement.scrollTop,
			backTopBtnDisplay;

	backTopBtn.id = 'backTopBtn';

	backTopBtn.href = '#pageWrapper';

	backTopBtn.classList.add('ccDyn-backTopBtn', 'uk-position-fixed','uk-position-bottom-right', 'uk-position-large');

	backTopBtn.setAttribute('data-uk-scroll', 'duration:700');
	backTopBtn.setAttribute('data-uk-icon', 'icon: chevron-up; ratio: 2');

	pageWrapper.appendChild(backTopBtn);

	backTopBtnDisplay = window.getComputedStyle(backTopBtn).display;

	if ( scrollTop > showPos && backTopBtnDisplay ==='none' ) {
		backTopBtn.style.display = 'block';
	}//endif

	window.addEventListener('scroll', function(event) {

		scrollTop = this.scrollY;
		
		backTopBtnDisplay = window.getComputedStyle(backTopBtn).display;
		if ( scrollTop > showPos ) {
			if ( backTopBtnDisplay ==='none' ) {
				backTopBtn.style.display = 'block';					
				animateCSS('#' + backTopBtn.id, 'fadeIn');
			}//endif
			
		} else {
			if ( backTopBtnDisplay ==='block' ) {
				animateCSS('#' + backTopBtn.id, 'fadeOut', function() {
					backTopBtn.style.display = 'none';
				});
				
				backTopBtn.blur();
			}//endif
		}//endif

	});

})();

/**
 * 
 */

// (function() {


// 	// UIkit.util.on('.cc-mainNav .cc-mainNav-sub2', 'shown', function () {

// 	// 	var DropdownHeight = this.clientHeight;

// 	// 	var SubNavs = this.querySelectorAll(".cc-mainNav-sub2");

// 	// 	if( !SubNavs ) return;

// 	// 	// Alternative fuer arr.foreach()
// 	// 	for ( var i = 0, len = SubNavs.length; i < len; i++ ) {

// 	// 		var subNav = SubNavs[i];

// 	// 		console.log(subNav);

// 	// 		subNav.style.minHeight = DropdownHeight;

// 	// 		//subNav.clientHeight(DropdownHeight);

// 	// 	}//end for
		
// 	// });

// })();

/**
 * Toggle Class ccDyn-emporiumNavDropDown-open
 */

(function() {

	var PageWrapper = document.getElementById('pageWrapper');

	UIkit.util.on('.cc-emporiumNav-dropDown', 'show', function () {
		PageWrapper.classList.add('ccDyn-emporiumNavDropDown-open');
	});

	UIkit.util.on('.cc-emporiumNav-dropDown', 'hide', function () {
		PageWrapper.classList.remove('ccDyn-emporiumNavDropDown-open');
	});

})();